import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface BookingErrorProps {
  type: 'expired' | 'invalid' | 'generic';
}

export function BookingError({ type }: BookingErrorProps) {
  const { t } = useTranslation();

  return (
    <div className='mx-auto max-w-md space-y-4 text-center'>
      <AlertCircle className='mx-auto h-16 w-16 text-red-400' />
      <p className='text-sm text-gray-600'>{t(`booking.error.${type}`)}</p>
    </div>
  );
}
